import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService, PrimeIcons } from 'primeng/api';
import { NGXLogger } from 'ngx-logger';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ActivatedRoute, Router } from '@angular/router';
import { OdaAtFirestore } from 'src/app/models/odaAtFirestore.model';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { environment } from 'src/environments/environment';
import { onSnapshot } from 'firebase/firestore';
import { UtilService } from 'src/app/services/util.service';
import { Menu } from 'primeng/menu';
import { v4 as uuidv4 } from 'uuid';

import { ExcelService } from 'src/app/services/excelService.service';
import { FiltroPratica, PraticaFlowdy2_Firestore } from 'src/app/models/praticaFirestore.model';
import { StiliService } from 'src/app/services/stili.service';
import { UserService } from 'src/app/services/user.service';
import { DialogEsitoSopralluogoFase1 } from '../../shared/esito-sopralluogo-fase1/esito-sopralluogo.component';
import { getBlob, getStorage, ref } from 'firebase/storage';
import { saveAs } from "file-saver";
import { DialogModificaPreventivoFase1 } from '../../shared/modifica-preventivo/modifica-preventivo.component';
import { DialogCaricaPreventivoFase1 } from '../../shared/carica-preventivo/carica-preventivo.component';
import { DialogAssegnaOdaFase1 } from '../../shared/assegna-oda/assegna-oda.component';
import { DialogCaricaDocumentoFase1 } from '../../shared/carica-documento/carica-documento.component';
import { PraticheService } from 'src/app/services/pratiche.service';
import { DialogRifiutaPreventivoFase1 } from '../../shared/rifiuta-preventivo/rifiuta-preventivo.component';
import { DialogVerificaConsegnaFase1 } from '../../shared/verifica-consegna-fase1/verifica-consegna.component';
import { DialogNoteReworkFase1 } from '../../shared/note-rework-fase1/note-rework.component';
import * as JSZip from 'jszip';
import { ComunicaBocciatura } from '../../shared/comunica-bocciatura/comunica_bocciatura.component';
import { DialogAccettazioneInvioInfratel } from '../../shared/comunica-accettazione/accettazione.component';
import { Location } from "@angular/common";
import { StoricoPraticaComponent } from '../../shared/storico/storico-pratica.component';
import { Utente } from 'src/app/models/utente.model';
import { OdaService } from 'src/app/services/oda.service';
import { DialogInvioInfratel } from '../../shared/comunica-invio-infratel/invio-infratel.component';
import { DialogPresidioTIMRifiutaPratica } from '../../shared/presidioTIM-rifiuta-pratica/presidioTIM_rifiuta_pratica.component';
import { ListeService } from 'src/app/services/liste.service';
import { DialogModificaDateAccettazioneInfratel } from '../../shared/modifica-date-accettazione/accettazione.component';
import { Impresa } from 'src/app/models/impresa.model';
import { ImpreseService } from 'src/app/services/imprese.service';
import { DialogNoteImpresa } from '../../shared/note-impresa/note-impresa.component';
import { DialogModificaStato } from '../../shared/modifica-stato/modifica_stato.component';
import { Dialog } from 'primeng/dialog';
import { DialogComunicaDataSopralluogoFase1 } from '../../shared/data-sopralluogo-fase1/data_sopralluogo_fase1.component';
import { StoricoNotePraticaComponent } from '../../shared/note-pratica/note-pratica.component';
import { CreaNotaPraticaComponent } from '../../shared/crea-note-pratica/crea-nota-pratica.component';

declare const CSVBoxImporter: any;

@Component({
    templateUrl: './fase1.bando1.component.html',
    styleUrls: ['./fase1.bando1.component.css'],
    providers: [DialogService, ConfirmationService],

})
export class PraticheFase1Bando1Component implements OnInit, OnDestroy {
    protected isLoadingResults:boolean = false;
    protected mostraPraticheCompletate:boolean = false;

    private importID: string; 

    protected showDeliverConfirmation:boolean = false;
    protected showAnnullaConsegnaConfirmation:boolean = false;
    protected showConfermaPreventivo:boolean = false;
    protected showResettaPratica:boolean = false;
    protected showFase1Approvata:boolean = false;
    protected showDettagliPratica:boolean = false;
    protected showDeletePraticaConfirmation:boolean = false;
    
    public isAdmin: boolean                     = false;
    public isSuperAdmin: boolean                = false;
    public isPresidioSF: boolean                = false;
    public isPresidioTIM: boolean               = false;
    public isDirigenteFirmaVerbali: boolean     = false;
    public isDirigenteFirmaPacchetti: boolean   = false;
    public isPM:boolean                         = false;
    public isContabile:boolean                  = false;
    public isImpresa:boolean                    = false;
    public isDemo:boolean                       = false;

    protected pratiche:PraticaFlowdy2_Firestore[] ;
    protected praticheFiltrate:PraticaFlowdy2_Firestore[] ;
    protected selectedPratica:PraticaFlowdy2_Firestore ;

    protected imprese:Impresa[]=[];

    @ViewChild("menuAzioni", { static: true }) azioniMenu: Menu;
    @ViewChild("menuAzioniTiered", { static: true }) azioniMenuTiered: Menu;

    protected menuAzioniItems!: MenuItem[];
    private _filtroPratiche!: FiltroPratica;

    get filtroPratiche(): FiltroPratica {
      return this._filtroPratiche;
    }
    
    set filtroPratiche(value: FiltroPratica) {
      this._filtroPratiche = value;
    }
    
    
    
    
  
 
    private collection_pratiche:string = environment.firebase.collection_pratiche;
    
    private ref: DynamicDialogRef;

    protected filterTabellaIsSet:boolean = false;
    protected filterIsSet:boolean = false;
    protected filtroInLavorazione:Boolean;
    protected filtroImpresa:String;
    protected filtroRegione:String;
    protected filtroTipoSedeEffettivaSop:String;
    protected ragioneSocialeImpresa:String="";
    protected statoSopralluogo:String="";
    protected filtroStatoSopralluogo:String;
    protected filtroLotto:String;
    protected filtroStatoInfratel:String;
    protected filtroStatoFlowdy:String;
    protected filtroOda:String;
    protected filtroDaPagare:boolean = false;
    protected filtroLottoPerFase:String;
    protected filtroPratica:string;
    protected paginaBack:string = null;
    
    private csvbox_licenseKey_comunicaEsitiConsegnaBando1:string=environment.csvBox.secret_comunicaEsitiConsegnaFase1;
    private csvbox_importer_comunicaEsitiConsegnaBando1:any;


    @ViewChild("praticheDT", { static: true }) praticheDT: any;
    
    constructor(
        private logger: NGXLogger,
        public firestore: AngularFirestore,
        public utilService:UtilService,
        protected stiliService:StiliService,
        private userService:UserService,
        public dialogService: DialogService,
        private messageService: MessageService,
        private confirmationService:ConfirmationService,
        private praticheService:PraticheService,
        private excelService:ExcelService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private location: Location,
        private odaService:OdaService,
        protected listeService:ListeService,
        private aziendeService: ImpreseService,

    ) {
      this._filtroPratiche = {};
      this.setUserRole();
      this.loadImprese();

    }
    loadImprese() {
      this.aziendeService.getByBando("1").subscribe((aziende) => {
        this.imprese = aziende;
      });
    }

    ngOnDestroy(): void {
    }

    ngOnInit() {
      this.initCSVBox();
      //// this.logger.info("ON ONIT FASE 1 BANDO 1");
      const urlParamInLavorazione   = this.activatedRoute.snapshot.paramMap.get('lavorazione');
      const urlParamLotto           = this.activatedRoute.snapshot.paramMap.get('lotto');
      const urlParamCodiceInfratel  = this.activatedRoute.snapshot.paramMap.get('stato');
      const urlParamOda             = this.activatedRoute.snapshot.paramMap.get('oda');
      this.activatedRoute.queryParamMap.subscribe((params) => {
        this.filtroDaPagare         = params.get('da-pagare') === 'true';
        this.filtroLottoPerFase     = params.get('lotto');
        this.filtroInLavorazione    = params.get('in-lavorazione')=== 'true';
        this.filtroImpresa          = params.get('impresa');
        this.filtroStatoSopralluogo = params.get('statoSopralluogo');
        this.filtroPratica          = params.get('pratica');
        this.filtroRegione          = params.get('regione');
        this.filtroStatoFlowdy      = params.get('stato-flowdy');
        this.paginaBack             = params.get('from');
        this.filtroTipoSedeEffettivaSop = params.get('tipoSedeEffettivaSop');
        if(this.filtroStatoSopralluogo ){
          this.filterIsSet = true;
          switch (this.filtroStatoSopralluogo) {
            case 'noSopralluogo':
              this.statoSopralluogo = 'SENZA SOPRALLUOGO';
              break;
            case 'noSopralluogoPF':
              this.statoSopralluogo = 'SENZA SOPRALLUOGO (PF)';
              break;
            case 'sopralluogoPianificato':
              this.statoSopralluogo = 'CON SOPRALLUOGO PIANIFICATO';
              break;
            case 'sopralluogoEseguito':
              this.statoSopralluogo = 'CON SOPRALLUOGO ESEGUITO';
              break;
            case 'sopralluogoKO':
              this.statoSopralluogo = 'CON SOPRALLUOGO KO';
              break;
            default:
              break;
          }
          
        }
        if(this.filtroImpresa){
          this.ragioneSocialeImpresa = params.get('ragioneSocialeImpresa');
        }

        if (this.filtroTipoSedeEffettivaSop) {
          const tipo = this.filtroTipoSedeEffettivaSop.toString().trim();
          if (tipo.length > 0) {
            if (!this._filtroPratiche.tipo) {
              this._filtroPratiche.tipo = [];
            }
            if (this._filtroPratiche.tipo.indexOf(tipo) === -1) {
              this._filtroPratiche.tipo.push(tipo);
            }
          }
        }

      });
      if(this.filtroInLavorazione || this.filtroImpresa || this.filtroPratica || this.filtroStatoSopralluogo || this.filtroStatoFlowdy){
        this.filterIsSet = true;
      }

     /*  this.activatedRoute.queryParamMap.subscribe((params) => {
       
      });
      this.activatedRoute.queryParamMap.subscribe((params) => {
       
        this.filterIsSet = true;
      }); */
      
      /* if(urlParamInLavorazione){
        this.filtroInLavorazione = urlParamInLavorazione;
        this.filterIsSet = true;
      } else  */if(urlParamLotto){
        this.filtroLotto = urlParamLotto;
        this.filterIsSet = true;
      }else if(urlParamCodiceInfratel){
        this.filtroStatoInfratel = urlParamCodiceInfratel;
        this.filterIsSet = true;
      }else if(urlParamOda){
        this.filtroOda = urlParamOda;
        this.filterIsSet = true;
      }else if(this.filtroStatoFlowdy){
        this.filtroStatoFlowdy = this.filtroStatoFlowdy;
        this.filterIsSet = true;
      }
       this.loadPratiche();
    }

    initCSVBox(){
      this.csvbox_importer_comunicaEsitiConsegnaBando1 = new CSVBoxImporter(this.csvbox_licenseKey_comunicaEsitiConsegnaBando1, {
      }, (result: boolean, data: any) => {
        if (result) {
          this.messageService.add({severity:'success', summary:'', detail: data.row_success + ' pratiche bando 1 AGGIORNATE con successo!', life:10000});
  
        } else {
          this.messageService.add({severity:'info', summary:'Errore', detail:'Errore in fase di INSERIMENTO DEGLI ESITI DELLA CONSEGNA DI FASE 1 delle pratiche del bando 1', life:10000});
        }
      });
      
      this.csvbox_importer_comunicaEsitiConsegnaBando1.setUser({
        user_id: "default123"
      });
      
     
      this.csvbox_importer_comunicaEsitiConsegnaBando1.language="it";
  
    
    }

    
    async openCaricaAzioni( event: any, pratica:PraticaFlowdy2_Firestore ): Promise<void> {
      this.selectedPratica = pratica;
      this.loadAzioni(event, pratica);
      this.azioniMenuTiered.toggle(event);
    }

    checkShowActionIcons(pratica:PraticaFlowdy2_Firestore):boolean{
      if(pratica.statoFlowdyFase1 === "ASSEGNATA" || pratica.statoFlowdyFase1 === 'SOPRALLUOGO EFFETTUATO' || pratica.statoFlowdyFase1 === "RESPINTA" || pratica.statoFlowdyFase1 === "IN REWORK AZIENDA" || pratica.statoFlowdyFase1 === "PREVENTIVO IN ATTESA" || pratica.statoFlowdyFase1 === "PREVENTIVO APPROVATO"){
        return true;
      }
      return false;
    }
   
    loadAzioni(event:any, pratica:PraticaFlowdy2_Firestore){
      this.menuAzioniItems = [];
      this.menuAzioniItems.push({
        label: "Storico",
        icon: PrimeIcons.HISTORY,
        style: {'font-size': '12px'},
        command: () => this.openStoricoPratica(pratica),
        },
       );
      
      if(this.isImpresa){ //IMPRESA
       
        if(pratica.statoFlowdyFase1 === "DA ASSEGNARE" ){
          this.menuAzioniItems.push(
            {
              label: "Prendi in carico",
               icon: 'icona-sf_in_carico',
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.openPrendiInCarico(pratica),
            },
           );
        }

        if(pratica.statoFlowdyFase1 === "ASSEGNATA"){
          this.menuAzioniItems.push(
              {
              label: "Data sopralluogo",
               icon: 'icona-data-sopralluogo',
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.comunicaDataSopralluogo(pratica),
            },
          );
        }
        if(pratica.statoFlowdyFase1 === "SOPRALLUOGO PIANIFICATO"){
          this.menuAzioniItems.push(
              {
              label: "Esito sopralluogo",
               icon: 'icona-comunica-esito',
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.comunicaEsitoSopralluogo(pratica),
            },
          );
        }


        if(pratica.statoFlowdyFase1 === "PREVENTIVO IN ATTESA" || pratica.statoFlowdyFase1 === "PREVENTIVO APPROVATO" || pratica.statoFlowdyFase1 === "PREVENTIVO RIFIUTATO" ){
          
          //gestione dei preventivi
          let itemsPreventivo:any[]=[];
          if(pratica.statoFlowdyFase1 !== "PREVENTIVO APPROVATO"){
            itemsPreventivo.push( {
              label: "Modifica",
               icon: 'pi pi-file-edit',
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.modificaPreventivo(pratica),
            });
          }
         /*  let itemsPreventivo:any[]=[
            {
              label: "Modifica",
               icon: 'pi pi-file-edit',
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.modificaPreventivo(pratica),
            }
          ]; */
          if(pratica.filePreventivoUploaded){
            itemsPreventivo.push(
              {
                label: "Scarica",
                 icon: 'pi pi-download',
                style: {  'font-size': '12px'},
                command: () => this.scaricaPreventivo(pratica),
              }/* ,
               */
            );
            if(pratica.statoFlowdyFase1 !== "PREVENTIVO APPROVATO"){
              itemsPreventivo.push(
                {
                  label: "Carica nuovo",
                   icon: 'pi pi-upload',
                  style: {  'font-size': '12px'},
                  command: () => this.caricaPreventivo(pratica),
                }
              );
            }
          }else{
            itemsPreventivo.push(
              {
                label: "Carica nuovo",
                 icon: 'pi pi-upload',
                style: {  'font-size': '12px'},
                command: () => this.caricaPreventivo(pratica),
              }
            );
          }

          this.menuAzioniItems.push(
            {
               label: "Preventivo",
                icon: 'icona-preventivo',
                style: {  'font-weight': 'bold', 'font-size': '12px'},
                items: itemsPreventivo
             },
           );


         
        }


        if( pratica.statoFlowdyFase1 === 'SOPRALLUOGO EFFETTUATO' || pratica.statoFlowdyFase1 === "RESPINTA" || pratica.statoFlowdyFase1 === "IN REWORK AZIENDA" || pratica.statoFlowdyFase1 === "PREVENTIVO IN ATTESA" || pratica.statoFlowdyFase1 === "PREVENTIVO APPROVATO")

        /* if(
            pratica.statoFlowdyFase1 !== "APPROVATA" && pratica.statoFlowdyFase1 !== "PUBBLICATA" && 
            pratica.statoFlowdyFase1 !== "CONSEGNATA" && 
            pratica.statoFlowdyFase1 !== "IN CARICO PRESIDIO" && 
            pratica.statoFlowdyFase1 !== "IN VERIFICA SMARTFIBER" 
            && (
              pratica.statoFlowdyFase1 === "IN REWORK AZIENDA" || 
              (!pratica.opereExtra && pratica.sopralluogoOk) || 
                 (pratica.opereExtra && (pratica.statoFlowdyFase1 === "PREVENTIVO IN ATTESA" ||  pratica.statoFlowdyFase1 === "PREVENTIVO APPROVATO") || (pratica.statoFlowdyFase1 === "RESPINTA"))
            )  ) */
          {
            //gestione dei documenti
            let itemsRT:any[]       =[];
            let itemsVerbale:any[]  =[];
            let itemsDUVRI:any[]    =[];
            let itemsAltri:any[]    =[];
            itemsRT.push({ 
                label: "Carica",
                icon: 'pi pi-upload',
                style: {  'font-size': '12px'},
                command: () => this.caricaDocumento(pratica, 'RET'),
            });

            itemsVerbale.push({ 
              label: "Carica",
              icon: 'pi pi-upload',
              style: {  'font-size': '12px'},
              command: () => this.caricaDocumento(pratica, 'VERBALE DEL SOPRALLUOGO'),   
            });
            itemsDUVRI.push({ 
              label: "Carica",
              icon: 'pi pi-upload',
              style: {  'font-size': '12px'},
              command: () => this.caricaDocumento(pratica, 'DUVRI'),
            });
            itemsAltri.push({ 
              label: "Carica",
              icon: 'pi pi-upload',
              style: {  'font-size': '12px'},
              command: () => this.caricaDocumento(pratica, 'ALTRI'),
            });

            if(pratica.fileRETUploaded){
              itemsRT.push({ 
                label: "Scarica",
                icon: 'pi pi-download',
                style: {  'font-size': '12px'},
                command: () => this.scaricaDoc(pratica, 'RET'),
              });
            } 
            if(pratica.fileVerbaleSopralluogoUploaded){
              itemsVerbale.push({ 
                label: "Scarica",
                   icon: 'pi pi-download',
                  style: {  'font-size': '12px'},
                  command: () => this.scaricaDoc(pratica, 'VERBALE'),
              });
            } 
            if(pratica.fileDUVRIUploaded){
              itemsDUVRI.push({ 
                label: "Scarica",
                icon: 'pi pi-download',
                style: {  'font-size': '12px'},
                command: () => this.scaricaDoc(pratica, 'DUVRI'),
              });
            } 
            if(pratica.fileAltriUploaded){
              itemsAltri.push({ 
                label: "Scarica",
                icon: 'pi pi-download',
                style: {  'font-size': '12px'},
                command: () => this.scaricaDoc(pratica, 'ALTRI'),
              });
            } 


          let itemsDocumenti:any[]=[
            {
              label: "RET",
              style: {  'font-size': '12px'},
              items:  itemsRT
            },
            {
              label: "Verbale Sopralluogo",
              style: {  'font-size': '12px'},
              items:itemsVerbale
            },
            {
              label: "DUVRI",
              style: {  'font-size': '12px'},
              items: itemsDUVRI
            },
            {
              label: "Altri",
              style: {  'font-size': '12px'},
              items:itemsAltri
            },
          ];

          if(pratica.fileRETUploaded || pratica.fileVerbaleSopralluogoUploaded  ||  pratica.fileDUVRIUploaded || pratica.fileAltriUploaded){
            itemsDocumenti.push(
            {
              label: "Scarica tutto",
               icon: 'pi pi-download',
              style: {  'font-size': '12px'},
              command: () => this.scaricaTuttaDocumentazione(pratica),
            });
          }
          if(pratica.noteSopralluogo && pratica.noteSopralluogo.length > 0){
            this.menuAzioniItems.push(
              {
                 label: "Mostra note",
                  icon: 'icona-note-impresa',
                  style: {   'font-size': '12px'},
                  command: () => this.apriNoteImpresa(pratica),
               },
             );
          }

          this.menuAzioniItems.push(
            {
               label: "Documentazione",
                icon: 'icona-documentazione',
                style: {  'font-weight': 'bold', 'font-size': '12px'},
                items: itemsDocumenti
             },
           );
          }
         
        if(this.checkIfDeliverable(pratica)){
          if(pratica.statoFlowdyFase1 !== "IN REWORK AZIENDA" ){
            this.menuAzioniItems.push(
              {
                  label: "Consegna",
                  icon: 'pi pi-send',
                  style: {  'font-weight': 'bold', 'font-size': '12px'},
                  command: () => this.consegnaPratica(pratica),
                },
              );
          }
         
        }

        if(pratica.statoFlowdyFase1 === "IN REWORK AZIENDA" ){
          let itemsPreventivo:any[]=[
            {
              label: "Modifica",
                icon: 'pi pi-file-edit',
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.modificaPreventivo(pratica),
            }
          ];
          if(pratica.filePreventivoUploaded){
            itemsPreventivo.push(
              {
                label: "Scarica",
                  icon: 'pi pi-download',
                style: {  'font-size': '12px'},
                command: () => this.scaricaPreventivo(pratica),
              },
              {
                label: "Carica nuovo",
                  icon: 'pi pi-upload',
                style: {  'font-size': '12px'},
                command: () => this.caricaPreventivo(pratica),
              }
            );
          }else{
            itemsPreventivo.push(
              {
                label: "Carica nuovo",
                  icon: 'pi pi-upload',
                style: {  'font-size': '12px'},
                command: () => this.caricaPreventivo(pratica),
              }
            );
          }

          this.menuAzioniItems.push(
            {
              label: "Preventivo",
                icon: 'icona-preventivo',
                style: {  'font-weight': 'bold', 'font-size': '12px'},
                items: itemsPreventivo
            },
          
              {
              label: "Riconsegna",
                icon: 'pi pi-send',
                style: {  'font-weight': 'bold', 'font-size': '12px'},
                command: () => this.consegnaPratica(pratica),
            }
            );
        }
        if(pratica.statoFlowdyFase1 === "CONSEGNATA" ){
          this.menuAzioniItems.push(
            {
                label: "Annulla consegna",
                icon: 'pi pi-undo',
                style: {  'font-weight': 'bold', 'font-size': '12px'},
                command: () => this.annullaConsegna(pratica),
              }
            );
        }

        if(pratica.statoFlowdyFase1 === "RESPINTA" ){
          this.menuAzioniItems.push(
            {
              label: "Note respingimento",
              icon: 'icona-note_rework',
              style: {   'font-size': '12px'},
              command: () => this.apriNoteRespingimento(pratica),
            },
            
            {
              label: "Riconsegna",
              icon: 'pi pi-send',
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.consegnaPratica(pratica),
            }
          );
        }
        if(pratica.statoFlowdyFase1 === "CONSEGNATA" ||  pratica.statoFlowdyFase1 === "IN VERIFICA SMARTFIBER" || pratica.statoFlowdyFase1 === "IN CARICO PRESIDIO" || pratica.statoFlowdyFase1 === "PUBBLICATA" || pratica.statoFlowdyFase1 === "APPROVATA"){
          this.menuAzioniItems.push(
            {
              label: "Scarica pacchetto",
                icon: 'icona-scarica_pacchetto',
                style: {   'font-size': '12px'},
              command: () => this.scaricaPacchettoPratica(pratica),
            },
          );
        }
      }else if(this.isPresidioSF|| this.isAdmin || this.isSuperAdmin || this.isDemo){ //AZIONI SF & ADMIN
        /* let itemsNote:any[]=[
          {
            label: "Aggiungi",
             icon: 'icona-note-presidio-aggiungi',
            style: {   'font-size': '12px'},
            command: () => this.aggiungiNota(pratica),
          },
          {
            label: "Visualizza",
             icon: 'icona-note-presidio-visualizza',
            style: {  'font-size': '12px'},
            command: () => this.visualizzaNote(pratica),
          },
        ]; */
        this.menuAzioniItems.push({
          label: "Note",
          icon: 'icona-note-presidio',
          style: {'font-size': '12px'},
          //items:itemsNote,
          command: () => this.visualizzaNote(pratica),
          },
         );
        if(pratica.statoFlowdyFase1 === "IN ATTESA ODA" ){
          this.menuAzioniItems.push(
            {
              label: "Elimina",
              icon: PrimeIcons.ERASER,
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.eliminaPratica(pratica),
            },
          );
          this.menuAzioniItems.push(
            {
               label: "Assegna ODA",
                icon: 'icona-assegna-oda',
               style: {  'font-weight': 'bold', 'font-size': '12px'},
               command: () => this.assegnaODA(pratica),
               disabled: this.isDemo
             },
           );
        }
        if(pratica.statoFlowdyFase1 === "DA ASSEGNARE" ){
          this.menuAzioniItems.push(
            {
              label: "Elimina",
              icon: PrimeIcons.ERASER,
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.eliminaPratica(pratica),
            },
          );
          this.menuAzioniItems.push(
            {
              label: "Prendi in carico",
               icon: 'icona-sf_in_carico',
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.openPrendiInCarico(pratica),
              disabled: this.isDemo
            },
           );
        }
       /*  this.menuAzioniItems.push({
          label: "Note",
          icon: 'icona-note-presidio',
          style: {'font-size': '12px'},
          //items:itemsNote,
          command: () => this.visualizzaNote(pratica),
          },
         ); */
        if(pratica.statoFlowdyFase1 === "ASSEGNATA"){
          this.menuAzioniItems.push(
              {
              label: "Data sopralluogo",
               icon: 'icona-data-sopralluogo',
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.comunicaDataSopralluogo(pratica),
              disabled: this.isDemo
            },
          );
        }
        if(pratica.statoFlowdyFase1 === "SOPRALLUOGO PIANIFICATO"){
          this.menuAzioniItems.push(
              {
              label: "Esito sopralluogo",
               icon: 'icona-comunica-esito',
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.comunicaEsitoSopralluogo(pratica),
              disabled: this.isDemo
            },
          );
        }

        if((pratica.statoFlowdyFase1 === 'CONSEGNATA' && pratica.statoPreventivo==='IN ATTESA') || pratica.statoFlowdyFase1 === "PREVENTIVO IN ATTESA" || pratica.statoFlowdyFase1 === "PREVENTIVO APPROVATO" || pratica.statoFlowdyFase1 === "PREVENTIVO RIFIUTATO" ){
          //gestione dei preventivi
          let itemsPreventivo:any[]=[
            {
              label: "Modifica",
               icon: 'pi pi-file-edit',
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.modificaPreventivo(pratica),
              disabled: this.isDemo
            }
          ];
          if(pratica.filePreventivoUploaded){
            itemsPreventivo.push(
              {
                label: "Scarica",
                 icon: 'pi pi-download',
                style: {  'font-size': '12px'},
                command: () => this.scaricaPreventivo(pratica),
              },
              {
                label: "Carica nuovo",
                 icon: 'pi pi-upload',
                style: {  'font-size': '12px'},
                command: () => this.caricaPreventivo(pratica),
                disabled: this.isDemo
              }
            );
          }else{
            itemsPreventivo.push(
              {
                label: "Carica nuovo",
                 icon: 'pi pi-upload',
                style: {  'font-size': '12px'},
                command: () => this.caricaPreventivo(pratica),
                disabled: this.isDemo
              }
            );
          }
          if(((pratica.statoFlowdyFase1 === 'CONSEGNATA' && pratica.statoPreventivo==='IN ATTESA') || pratica.statoFlowdyFase1 === "PREVENTIVO IN ATTESA" || pratica.statoFlowdyFase1 === "PREVENTIVO RIFIUTATO") && pratica.filePreventivoUploaded){
            itemsPreventivo.push(
              {
                label: "Approva",
                 icon: 'pi pi-thumbs-up-fill',
                style: {  'font-size': '12px'},
                command: () => this.approvaPreventivo(pratica),
                disabled: this.isDemo
              },
              {
                label: "Rifiuta",
                 icon: 'pi pi-thumbs-down-fill',
                style: {  'font-size': '12px'},
                command: () => this.rifiutaPreventivo(pratica),
                disabled: this.isDemo
              },
            );
          }
          this.menuAzioniItems.push(
            {
               label: "Preventivo",
                icon: 'icona-preventivo',
                style: {  'font-weight': 'bold', 'font-size': '12px'},
                items: itemsPreventivo
             },
           );

          
        }
        
        if( pratica.statoFlowdyFase1 === 'SOPRALLUOGO EFFETTUATO' || 
          pratica.statoFlowdyFase1 === "RESPINTA" || 
          pratica.statoFlowdyFase1 === "IN REWORK AZIENDA" || 
          pratica.statoFlowdyFase1 === "PREVENTIVO IN ATTESA" || 
          pratica.statoFlowdyFase1 === "PREVENTIVO APPROVATO" || 
          pratica.statoFlowdyFase1 === 'CONSEGNATA' ||
          pratica.statoFlowdyFase1 === 'IN VERIFICA SMARTFIBER')

        /* }
        if(
          pratica.statoFlowdyFase1 !== "APPROVATA" && pratica.statoFlowdyFase1 !== "PUBBLICATA" &&  
          pratica.statoFlowdyFase1 === "IN REWORK AZIENDA" 
          || pratica.statoFlowdyFase1 === "RESPINTA" || 
          (!pratica.opereExtra && pratica.sopralluogoOk) || (pratica.opereExtra && (pratica.statoFlowdyFase1 === "PREVENTIVO IN ATTESA" || pratica.statoFlowdyFase1 === "PREVENTIVO APPROVATO"))) 
          */ {
            //gestione dei documenti
            let itemsRT:any[]       =[];
            let itemsVerbale:any[]  =[];
            let itemsDUVRI:any[]    =[];
            let itemsAltri:any[]    =[];
            itemsRT.push({ 
                label: "Carica",
                icon: 'pi pi-upload',
                style: {  'font-size': '12px'},
                command: () => this.caricaDocumento(pratica, 'RET'),
                disabled: this.isDemo
            });

            itemsVerbale.push({ 
              label: "Carica",
              icon: 'pi pi-upload',
              style: {  'font-size': '12px'},
              command: () => this.caricaDocumento(pratica, 'VERBALE DEL SOPRALLUOGO'),   
              disabled: this.isDemo
            });
            itemsDUVRI.push({ 
              label: "Carica",
              icon: 'pi pi-upload',
              style: {  'font-size': '12px'},
              command: () => this.caricaDocumento(pratica, 'DUVRI'),
              disabled: this.isDemo
            });
            itemsAltri.push({ 
              label: "Carica",
              icon: 'pi pi-upload',
              style: {  'font-size': '12px'},
              command: () => this.caricaDocumento(pratica, 'ALTRI'),
              disabled: this.isDemo
            });

            if(pratica.fileRETUploaded){
              itemsRT.push({ 
                label: "Scarica",
                icon: 'pi pi-download',
                style: {  'font-size': '12px'},
                command: () => this.scaricaDoc(pratica, 'RET'),
              });
            } 
            if(pratica.fileVerbaleSopralluogoUploaded){
              itemsVerbale.push({ 
                label: "Scarica",
                   icon: 'pi pi-download',
                  style: {  'font-size': '12px'},
                  command: () => this.scaricaDoc(pratica, 'VERBALE'),
              });
            } 
            if(pratica.fileDUVRIUploaded){
              itemsDUVRI.push({ 
                label: "Scarica",
                icon: 'pi pi-download',
                style: {  'font-size': '12px'},
                command: () => this.scaricaDoc(pratica, 'DUVRI'),
              });
            } 
            if(pratica.fileAltriUploaded){
              itemsAltri.push({ 
                label: "Scarica",
                icon: 'pi pi-download',
                style: {  'font-size': '12px'},
                command: () => this.scaricaDoc(pratica, 'ALTRI'),
              });
            } 


          let itemsDocumenti:any[]=[
            {
              label: "RET",
              style: {  'font-size': '12px'},
              items:  itemsRT
            },
            {
              label: "Verbale Sopralluogo",
              style: {  'font-size': '12px'},
              items:itemsVerbale
            },
            {
              label: "DUVRI",
              style: {  'font-size': '12px'},
              items: itemsDUVRI
            },
            {
              label: "Altri",
              style: {  'font-size': '12px'},
              items:itemsAltri
            },
          ];

          if(pratica.fileRETUploaded || pratica.fileVerbaleSopralluogoUploaded  ||  pratica.fileDUVRIUploaded || pratica.fileAltriUploaded){
            itemsDocumenti.push(
            {
              label: "Scarica tutto",
               icon: 'pi pi-download',
              style: {  'font-size': '12px'},
              command: () => this.scaricaTuttaDocumentazione(pratica),
            });
          }

          if(pratica.noteBocciaturaPresidio && pratica.noteBocciaturaPresidio.length > 0){
            this.menuAzioniItems.push(
              {
                 label: "Mostra note presidio",
                  icon: 'icona-documentazione',
                  style: {   'font-size': '12px'},
                  command: () => this.apriNoteBocciaturaPresidio(pratica),
               },
             );
          }
         
          if(pratica.noteSopralluogo && pratica.noteSopralluogo.length > 0){
            this.menuAzioniItems.push(
              {
                 label: "Note sopralluogo",
                  icon: 'icona-note-impresa',
                  style: {   'font-size': '12px'},
                  command: () => this.apriNoteImpresa(pratica),
               },
             );
          }
          if( pratica.statoFlowdyFase1 !== "IN REWORK AZIENDA" && (pratica.noteRET ||  pratica.noteDUVRI || pratica.noteVerbale)){
            this.menuAzioniItems.push(
              {
                label: "Note rework",
                icon: 'icona-note_rework',
                style: {   'font-size': '12px'},
                command: () => this.apriNoteRework(pratica),
              });
          }
          
         
          this.menuAzioniItems.push(
            {
               label: "Documentazione",
                icon: 'icona-documentazione',
                style: {  'font-weight': 'bold', 'font-size': '12px'},
                items: itemsDocumenti
             },
           );
          }
         
          //se tutta la documentazione caricata -> consegna
          if((!pratica.opereExtra && pratica.sopralluogoOk) || 
            (
              pratica.opereExtra && (pratica.statoFlowdyFase1 === "PREVENTIVO IN ATTESA" || pratica.statoFlowdyFase1 === "PREVENTIVO APPROVATO")
            )
          ) {
            //
          }
          if(this.checkIfDeliverable(pratica)){
            if(pratica.statoFlowdyFase1 !== "IN REWORK AZIENDA" ){
              this.menuAzioniItems.push(
                {
                   label: "Consegna",
                    icon: 'pi pi-send',
                    style: {  'font-weight': 'bold', 'font-size': '12px'},
                    command: () => this.consegnaPratica(pratica),
                    disabled: this.isDemo
                 },
               );
            }
            
          }

          if(pratica.statoFlowdyFase1 === "IN REWORK AZIENDA" ){
            let itemsPreventivo:any[]=[
              {
                label: "Modifica",
                 icon: 'pi pi-file-edit',
                style: {  'font-weight': 'bold', 'font-size': '12px'},
                command: () => this.modificaPreventivo(pratica),
                disabled: this.isDemo
              }
            ];
            if(pratica.filePreventivoUploaded){
              itemsPreventivo.push(
                {
                  label: "Scarica",
                   icon: 'pi pi-download',
                  style: {  'font-size': '12px'},
                  command: () => this.scaricaPreventivo(pratica),
                },
                {
                  label: "Carica nuovo",
                   icon: 'pi pi-upload',
                  style: {  'font-size': '12px'},
                  command: () => this.caricaPreventivo(pratica),
                  disabled: this.isDemo
                }
              );
            }else{
              itemsPreventivo.push(
                {
                  label: "Carica nuovo",
                   icon: 'pi pi-upload',
                  style: {  'font-size': '12px'},
                  command: () => this.caricaPreventivo(pratica),
                  disabled: this.isDemo
                }
              );
            }

            this.menuAzioniItems.push(
              {
                label: "Preventivo",
                 icon: 'icona-preventivo',
                 style: {  'font-weight': 'bold', 'font-size': '12px'},
                 items: itemsPreventivo
              },
              {
                 label: "Note rework",
                  icon: 'icona-note_rework',
                 style: {   'font-size': '12px'},
                 command: () => this.apriNoteRework(pratica),
               },
              
               {
                label: "Riconsegna",
                 icon: 'pi pi-send',
                 style: {  'font-weight': 'bold', 'font-size': '12px'},
                 command: () => this.consegnaPratica(pratica),
                 disabled: this.isDemo
              }
              );
          }
        
          if(pratica.statoFlowdyFase1 === "CONSEGNATA" ){
            this.menuAzioniItems.push(
              {
                 label: "Annulla consegna",
                  icon: 'pi pi-undo',
                 style: {  'font-weight': 'bold', 'font-size': '12px'},
                 command: () => this.annullaConsegna(pratica),
                 disabled: this.isDemo
               },
               {
                label: "Prendi in carico",
                 icon: 'icona-sf_in_carico',
                style: {  'font-weight': 'bold', 'font-size': '12px'},
                command: () => this.openPrendiInCarico(pratica),
                disabled: this.isDemo
              },
             );
          }

          if(pratica.statoFlowdyFase1 === "IN VERIFICA SMARTFIBER" ){
            this.menuAzioniItems.push(
              /* {
                label: "Scarica tutto",
                 icon: 'pi pi-download',
                style: {  'font-size': '12px'},
                command: () => this.scaricaTuttaDocumentazione(pratica),
              }, */
              {
                label: "Valida consegna",
                 icon: 'icona-validazione-consegna',
                style: { 'font-weight': 'bold', 'font-size': '12px'},
                command: () => this.validaConsegna(pratica),
                disabled: this.isDemo
              },
             );
          }

          if(pratica.statoFlowdyFase1 === "SOPRALLUOGO KO" ){
            this.menuAzioniItems.push(
              {
                label: "Nuovo Sopralluogo",
                icon: 'icona-comunica-esito',
                style: {  'font-weight': 'bold', 'font-size': '12px'},
                command: () => this.comunicaEsitoSopralluogo(pratica),
                disabled: this.isDemo
              },
             );
          }

         
         

           if(pratica.statoFlowdyFase1 === "RESPINTA" ){
            this.menuAzioniItems.push(
              {
                label: "Note respingimento",
                icon: 'icona-note_rework',
                style: {   'font-size': '12px'},
                command: () => this.apriNoteRespingimento(pratica),
              },
              {
                label: "Riconsegna",
                icon: 'pi pi-send',
                style: {  'font-weight': 'bold', 'font-size': '12px'},
                command: () => this.consegnaPratica(pratica),
                disabled: this.isDemo
              }
            );
          }
          if(pratica.statoFlowdyFase1 === "IN CARICO PRESIDIO" || pratica.statoFlowdyFase1 === "PUBBLICATA" || pratica.statoFlowdyFase1 === "APPROVATA"){
            this.menuAzioniItems.push(
              {
                label: "Scarica pacchetto",
                 icon: 'icona-scarica_pacchetto',
                 style: {   'font-size': '12px'},
                command: () => this.scaricaPacchettoPratica(pratica),
              },
            );
          }
         // if(pratica.statoFlowdyFase1 !== "PUBBLICATA" && pratica.statoFlowdyFase1 !== "APPROVATA"){
            this.menuAzioniItems.push(
              {
                label: "Cambia Stato",
                  icon: 'icona-forza_stato',
                 style: {  'font-weight': 'bold', 'font-size': '12px'},
                 command: () => this.forzaStatoPratica(pratica),
                 disabled: this.isDemo
              },
              {
                 label: "Resetta",
                  icon: 'icona-reset',
                 style: {  'font-weight': 'bold', 'font-size': '12px'},
                 command: () => this.resettaPratica(pratica),
                 disabled: this.isDemo
               },
             );
          //}
        


       
      }else if(this.isPresidioTIM){ //AZIONI PRESIDIO TIM 
        //SCARICA PACCHETTI DI PRATICHE CON TUTTO OK
        this.menuAzioniItems.push({
          label: "Note",
          icon: 'icona-note-presidio',
          style: {'font-size': '12px'},
          //items:itemsNote,
          command: () => this.visualizzaNote(pratica),
          },
         );
        this.menuAzioniItems.push(
          {
             label: "Scarica pacchetto",
              icon: 'icona-scarica_pacchetto',
              style: {   'font-size': '12px'},
             command: () => this.scaricaPacchettoPratica(pratica),
           }
          );
        if(pratica.statoFlowdyFase1 === "IN CARICO PRESIDIO"){
          this.menuAzioniItems.push(
           
             {
             label: "Invio Infratel",
               icon: 'icona-invio-infratel',
              style: {  'font-weight': 'bold', 'font-size': '11px'},
              command: () => this.comunicaInvioInfratelPratica(pratica),
            },
            {
              label: "Rifiuta consegna",
                icon: 'icona-rifiuta_consegna',
               style: {  'font-weight': 'bold', 'font-size': '11px'},
               command: () => this.rifiutaConsegna(pratica),
             }
           );
          }
          if(pratica.statoFlowdyFase1 === "PUBBLICATA"){
            this.menuAzioniItems.push(
             {
              label: "Esito",
               icon: 'icona-comunica_esito',
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              items:[
                {
                  label: "Approvata",
                   icon: 'icona-fase1_approvata',
                  style: {  'font-size': '12px'},
                  command: () => this.comunicaEsitoFase1(pratica, true),
                },
                {
                  label: "Respinta",
                   icon: 'icona-fase1_respinta',
                  style: {  'font-size': '12px'},
                  command: () => this.comunicaEsitoFase1(pratica, false),
                }
              ],
            });
          }
          /* if(pratica.statoFlowdyFase1 === "PUBBLICATA" || pratica.statoFlowdyFase1 === "APPROVATA"){
            this.menuAzioniItems.push(
              {
              label: "Modifica Date",
               icon: 'pi pi-calendar',
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.modificaDateEsitoInfratel(pratica),
            })
            ;
          } */
        //MODIFICA LO STATO IN APPROVATE
      }else if(this.isPM){ //AZIONI PRESIDIO PM 
        //SCARICA/APPROVA/RIFIUTA PREVENTIVO
        this.menuAzioniItems.push({
          label: "Note",
          icon: 'icona-note-presidio',
          style: {'font-size': '12px'},
          command: () => this.visualizzaNote(pratica),
          },
        );
        
        let itemsPreventivo:any[]=[
         ];
        itemsPreventivo.push(
          {
            label: "Scarica",
             icon: 'pi pi-download',
            style: {  'font-size': '12px'},
            command: () => this.scaricaPreventivo(pratica),
          },
          {
            label: "Approva",
             icon: 'pi pi-thumbs-up-fill',
            style: {  'font-weight': 'bold', 'font-size': '12px'},
            command: () => this.approvaPreventivo(pratica),
          },
          {
            label: "Rifiuta",
             icon: 'pi pi-thumbs-down-fill',
            style: {  'font-weight': 'bold', 'font-size': '12px'},
            command: () => this.rifiutaPreventivo(pratica),
          },
        );
      
        this.menuAzioniItems.push(
          {
            label: "Preventivo",
             icon: 'icona-preventivo',
             style: {  'font-weight': 'bold', 'font-size': '12px'},
             items: itemsPreventivo
          }
        );
      }else if(this.isDirigenteFirmaPacchetti){
        this.menuAzioniItems.push({
          label: "Note",
          icon: 'icona-note-presidio',
          style: {'font-size': '12px'},
          command: () => this.visualizzaNote(pratica),
          },
        );
      }
      
    }

    modificaDateEsitoInfratel(pratica: PraticaFlowdy2_Firestore) {
      this.ref = this.dialogService.open(DialogModificaDateAccettazioneInfratel, {
        data: {
          pratica: pratica,
          fase:1
        },
        header: "Modifica le date di accettazione della FASE 1 della pratica "+ pratica.cui.toUpperCase(),
        width: "60%",
        height: "35%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((bocciaturaFase1) => {
        if (bocciaturaFase1 && bocciaturaFase1.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Date accettazione della pratica modificate!', life:3000});
        }
      }); 
    }

    importaEsitiConsegna(){
      this.importID = uuidv4();
      this.csvbox_importer_comunicaEsitiConsegnaBando1.setUser({
          importID: this.importID,
        });
      this.csvbox_importer_comunicaEsitiConsegnaBando1.openModal();
    }

    aggiungiNota(pratica: PraticaFlowdy2_Firestore) {
      this.isLoadingResults = true;
      
        this.ref = this.dialogService.open(CreaNotaPraticaComponent, {
          data: {
            pratica: pratica,
          },
          header: "Crea NOTA per la pratica "+pratica.cui,
          width: "50%",
          height: "55%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
        this.ref.onClose.subscribe((creaNota) => {
          if (creaNota && creaNota.success) {
            this.messageService.add({severity:'success', summary:'', detail:'Nota creata con successo!', life:3000});
          }
        }); 
        this.isLoadingResults = false;
          
    
    }
   
    openStoricoPratica(pratica: PraticaFlowdy2_Firestore) {
      this.isLoadingResults = true;
      this.praticheService.getStorico(pratica.id).subscribe(storicoPratica=>{
        this.isLoadingResults = false;
          if(storicoPratica && storicoPratica.length > 0){
            // this.logger.info(storicoPratica);
            this.ref = this.dialogService.open(StoricoPraticaComponent, {
              data: {
                pratica: pratica,
                storicoPratica: storicoPratica,
                fase:1
              },
              header: "Storico della FASE 1 della pratica "+pratica.cui,
              width: "50%",
              height: "85%",
              baseZIndex: 10000,
              closable: true,
              draggable: false,
            });
            this.isLoadingResults = false;
          }else{
            this.messageService.add({
              severity: "info",
              summary: "Attenzione!",
              detail: "La pratica non presenta STORICO",
            });
            this.isLoadingResults = false;
          }
      }); 
    }

    apriNoteRespingimento(pratica:PraticaFlowdy2_Firestore){
      this.ref = this.dialogService.open(DialogNoteReworkFase1, {
       data: {
         pratica: pratica,
         isRespigimento:true,
       },
       header: "Note relative al RESPINGIMENTO della pratica "+ pratica.cui.toUpperCase(),
       width: "60%",
       height: "70%",
       baseZIndex: 10000,
       closable: true,
       draggable: false,
     }); 
   }

   getTipoSedeAbbreviata(tipoSede:string):string{
    if(tipoSede.startsWith("M")){
      return "Mand. "+tipoSede.charAt(tipoSede.length-1);

    }else{
      return "Agg. "+tipoSede.charAt(tipoSede.length-1);
    }
  }

  rifiutaConsegna(pratica:PraticaFlowdy2_Firestore){
    this.ref = this.dialogService.open(DialogPresidioTIMRifiutaPratica, {
      data: {
        pratica: pratica,
        fase:"1"
      },
      header: "Rifiuta la consegna della FASE 1 della pratica "+ pratica.cui.toUpperCase(),
      width: "60%",
      height: "50%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((rifiutoOK) => {
      if (rifiutoOK && rifiutoOK.success) {
        this.messageService.add({severity:'success', summary:'', detail:'Consegna rifiutata !', life:3000});
      }
    }); 

  }

    rifiutaPreventivo(pratica:PraticaFlowdy2_Firestore){
      this.ref = this.dialogService.open(DialogRifiutaPreventivoFase1, {
        data: {
          pratica: pratica,
        },
        header: "Rifiuta preventivo per la pratica "+ pratica.cui.toUpperCase(),
        width: "60%",
        height: "50%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((modificaPreventivo) => {
        if (modificaPreventivo && modificaPreventivo.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Preventivo rifiutato!', life:3000});
        }
      }); 

    }


    comunicaEsitoFase1(pratica:PraticaFlowdy2_Firestore, isApprovata:boolean){
      if(isApprovata){
        this.ref = this.dialogService.open(DialogAccettazioneInvioInfratel, {
          data: {
            pratica: pratica,
            fase:1
          },
          header: "Accettazione della FASE 1 della pratica "+ pratica.cui.toUpperCase(),
          width: "60%",
          height: "35%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
        this.ref.onClose.subscribe((bocciaturaFase1) => {
          if (bocciaturaFase1 && bocciaturaFase1.success) {
            this.messageService.add({severity:'success', summary:'', detail:'Accettazione della pratica comuinicata!', life:3000});
          }
        }); 
      }else{
        this.ref = this.dialogService.open(ComunicaBocciatura, {
          data: {
            pratica: pratica,
            fase:1
          },
          header: "Indica le moditivazioni della bocciatura della FASE 1 della pratica "+ pratica.cui.toUpperCase(),
          width: "60%",
          height: "70%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
        this.ref.onClose.subscribe((bocciaturaFase1) => {
          if (bocciaturaFase1 && bocciaturaFase1.success) {
            this.messageService.add({severity:'success', summary:'', detail:'Bocciatura pratica comuinicata!', life:3000});
          }
        }); 
      }
     
    }

    comunicaInvioInfratelPratica(pratica:PraticaFlowdy2_Firestore){
      
        this.ref = this.dialogService.open(DialogInvioInfratel, {
          data: {
            pratica: pratica,
            fase:1
          },
          header: "Comunicazione invio ad INFRATEL della FASE 1 della pratica "+ pratica.cui.toUpperCase(),
          width: "50%",
          height: "80%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
        this.ref.onClose.subscribe((invioFase1) => {
          if (invioFase1 && invioFase1.success) {
            this.messageService.add({severity:'success', summary:'', detail:'Invio della pratica ad INFRATEL comuinicato!', life:3000});
          }
        }); 
     }

    confermaApprovazioneFase1(){
      this.showFase1Approvata = false;
      this.selectedPratica = null;
    }

   

    eliminaPratica(pratica:PraticaFlowdy2_Firestore){
      this.showDeletePraticaConfirmation = true;
      this.selectedPratica = pratica;
    }
    confermaEliminazionePratica(){
      this.isLoadingResults = true;
      this.praticheService.eliminaPratica(this.selectedPratica.id).subscribe( {
        next: (v) => {
          // this.logger.info("NEXT");
          this.isLoadingResults = false;
          this.showDeletePraticaConfirmation = false;
          this.selectedPratica = null;
          this.messageService.add({severity:'success', summary:'', detail:'Pratica eliminata!', life:5000});
          
        },
        error: (e) => {
            this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di ELIMINAZIONE della pratica'});
            this.isLoadingResults = false;
            this.showDeletePraticaConfirmation = false;
            this.selectedPratica = null;
        },
        complete: () => {
          // this.logger.info("COMPLETE");
        }
      });
    }

    
    
    forzaStatoPratica(pratica: PraticaFlowdy2_Firestore) {
        this.ref = this.dialogService.open(DialogModificaStato, {
          data: {
            pratica: pratica,
            fase:1
          },
          header: "Cambio stato della Pratica "+pratica.cui,
          width: "50%",
          height: "40%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
        this.ref.onClose.subscribe((statoUpdated) => {
          if (statoUpdated && statoUpdated.success) {
            this.isLoadingResults = false;
            this.messageService.add({
              severity: "success",
              summary: "" , life:10000,
              detail: "Stato della pratica "+ pratica.cui+" aggiornato con successo",
            });
          }
        });
      }

    async scaricaPacchettoPratica(pratica:PraticaFlowdy2_Firestore){
      const storage = getStorage();
      const zipPratica = new JSZip();
      this.isLoadingResults = true;
      const pathReferenceRET      = ref(  storage, "pratiche/scuola/" +  pratica.cui + "/IN/FASE_1/documentazione/"+pratica.cui+ "_RET.docx" );
      const pathReferenceDUVRI    = ref(  storage, "pratiche/scuola/" +  pratica.cui + "/IN/FASE_1/documentazione/"+pratica.cui+ "_DUVRI.pdf" );
      const pathReferenceVerbale  = ref(  storage, "pratiche/scuola/" +  pratica.cui + "/IN/FASE_1/documentazione/"+pratica.cui+ "_VERBALE.pdf" );
      let filesToDownload = [
        pathReferenceRET,  
        pathReferenceDUVRI,
        pathReferenceVerbale
      ];
      const downloadPromises = [];
      for (const pathRef of filesToDownload) {
        try {
          const blob = await getBlob(pathRef);
          if (blob) {
            zipPratica.file(pathRef.name, blob);
            downloadPromises.push(Promise.resolve());
          }else {
            this.logger.error(`Errore durante il download di ${pathRef.name}`);
            downloadPromises.push(Promise.reject());
          }  
        }catch (error) {
            this.isLoadingResults = false;
            // this.logger.info(pathRef.name);
        }
      }
      Promise.all(downloadPromises)
      .then(() => {
        zipPratica.generateAsync({ type: 'blob' })
        .then((blob) => {
          saveAs(blob, pratica.cui+'_FASE1.zip'); 
          this.isLoadingResults = false;
        })
        .catch(error => console.error('Errore durante la creazione dello zip:', error));
      });
      this.isLoadingResults = false;
    }

    resettaPratica(pratica:PraticaFlowdy2_Firestore){
      this.showResettaPratica = true;
      this.selectedPratica = pratica;
    }
    confermaResetPratica(){
      this.isLoadingResults = true;
      this.praticheService.resetFase1(this.selectedPratica.id).subscribe( {
        next: (v) => {
          // this.logger.info("NEXT");
          this.isLoadingResults = false;
          this.showResettaPratica = false;
          this.selectedPratica = null;
          this.messageService.add({severity:'success', summary:'', detail:'Pratica resettata!', life:5000});
          
        },
        error: (e) => {
            this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di reset della pratica'});
            this.isLoadingResults = false;
            this.showResettaPratica = false;
            this.selectedPratica = null;
        },
        complete: () => {
          // this.logger.info("COMPLETE");
        }
      });
    }

    approvaPreventivo(pratica:PraticaFlowdy2_Firestore){
      this.showConfermaPreventivo = true;
      this.selectedPratica = pratica;
    }

    confermaApprovaPreventivo(){
      this.isLoadingResults = true;
      this.praticheService.approvaPreventivo(this.selectedPratica.id).subscribe( {
        next: (v) => {
          this.isLoadingResults = false;
          this.messageService.add({severity:'success', summary:'', detail:'Preventivo della pratica ' + this.selectedPratica.cui+ ' approvato!', life:5000});
          this.showConfermaPreventivo = false;
          this.selectedPratica = null;
        },
        error: (e) => {
            this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di approvazione del preventivo della pratica'});
            this.isLoadingResults = false;
            this.showConfermaPreventivo = false;
            this.selectedPratica = null;
        },
        complete: () => {
        }
      });
    }

    caricaPreventivo(pratica:PraticaFlowdy2_Firestore){
      this.ref = this.dialogService.open(DialogCaricaPreventivoFase1, {
        data: {
          pratica: pratica,
        },
        header: "Carica file del PREVENTIVO per la pratica "+ pratica.cui.toUpperCase(),
        width: "40%",
        height: "40%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((modificaPreventivo) => {
        if (modificaPreventivo && modificaPreventivo.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Preventivo caricato con successo!', life:3000});
        }
      }); 
    }

    validaConsegna(pratica: PraticaFlowdy2_Firestore) {
      this.ref = this.dialogService.open(DialogVerificaConsegnaFase1, {
        data: {
          pratica: pratica,
        },
        header: "Validazione della consegna della pratica "+ pratica.cui.toUpperCase(),
        width: "80%",
        height: "90%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((consegnaValidata) => {
        if (consegnaValidata && consegnaValidata.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Consegna validata con successo!', life:3000});
          this.loadPratiche();
        }
      }); 
    }

    async scaricaTuttaDocumentazione(pratica: PraticaFlowdy2_Firestore) {
      const storage = getStorage();
      if(pratica.fileRETUploaded){
        this.scaricaDoc(pratica,'RET');
      }
      if(pratica.fileVerbaleSopralluogoUploaded){
        this.scaricaDoc(pratica,'VERBALE');
      }
      if(pratica.fileDUVRIUploaded){
        this.scaricaDoc(pratica,'DUVRI');
      }
      if(pratica.fileAltriUploaded){
        this.scaricaDoc(pratica,'ALTRI');
      }
    }

    async scaricaDoc(pratica: PraticaFlowdy2_Firestore, tipoDocumento :string) {
      const storage = getStorage();
      if(tipoDocumento!=='ALTRI'){
        this.isLoadingResults = true;
        if(tipoDocumento==='RET'){
          let pathReferenceDoc = ref(
            storage,
            "pratiche/scuola/" +
            pratica.cui +
              "/IN/FASE_1/documentazione/"+pratica.cui+ "_RET.docx"
          );
          const blobDoc = await getBlob(pathReferenceDoc);
          saveAs(blobDoc, pratica.cui+"_RET.docx");
        }else{
          let file:string = tipoDocumento==='DUVRI'?"DUVRI":"VERBALE";
          let pathReferenceDoc = ref(
            storage,
            "pratiche/scuola/" +
            pratica.cui +
              "/IN/FASE_1/documentazione/"+pratica.cui+ "_"+file+".pdf"
          );
          const blobDoc = await getBlob(pathReferenceDoc);
          saveAs(blobDoc, pratica.cui+"_"+file+".pdf");
        }
        
        
      }else{
        if(pratica.listaAltriFileUploaded && pratica.listaAltriFileUploaded.length > 0){
          for(let file of pratica.listaAltriFileUploaded){
            this.isLoadingResults = true;
            const pathReferenceDoc = ref(
              storage,
              "pratiche/scuola/" +
              pratica.cui +
                "/IN/FASE_1/documentazione/"+file
            );
      
            const blobDoc = await getBlob(pathReferenceDoc);
            saveAs(blobDoc, file);
          }
        }
      }
     
      this.isLoadingResults = false;
    }

    caricaDocumento(pratica: PraticaFlowdy2_Firestore, tipoDocumento :string) {
      let header = "Caricamento ";
      if(tipoDocumento==='ALTRI'){
        header+="di ALTRI DOCUMENTI per la pratica "+ pratica.cui.toUpperCase();
      }else{
        header += "del";
        if(tipoDocumento==='RET'){
          header+="la"
        };
        header+=" " + tipoDocumento+" per la pratica "+ pratica.cui.toUpperCase();
      }
  
      this.ref = this.dialogService.open(DialogCaricaDocumentoFase1, {
        data: {
          pratica: pratica,
          tipoDoc:tipoDocumento,
        },
        header: header,
        width: "50%",
        height: "50%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((caricamentoDoc) => {
        if (caricamentoDoc && caricamentoDoc.success) {
          this.messageService.add({severity:'success', summary:'', detail: tipoDocumento!=='ALTRI'?tipoDocumento +' caricato con successo!':'Altro documento caricato con successo', life:3000});
        }
      }); 
    }
    
    apriNoteRework(pratica:PraticaFlowdy2_Firestore){
      this.ref = this.dialogService.open(DialogNoteReworkFase1, {
        data: {
          pratica: pratica,
        },
        header: "Note per il REWORK della FASE 1 della pratica "+ pratica.cui.toUpperCase(),
        width: "60%",
        height: "70%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
    }

    apriNoteImpresa(pratica:PraticaFlowdy2_Firestore){
      this.ref = this.dialogService.open(DialogNoteImpresa, {
        data: {
          pratica: pratica,
          noteImpresa: pratica.noteSopralluogo
        },
        header: "Note indicate in fase di comunicazione del sopralluogo della pratica "+ pratica.cui.toUpperCase(),
        width: "60%",
        height: "40%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
    }

    apriNoteBocciaturaPresidio(pratica:PraticaFlowdy2_Firestore){
      this.ref = this.dialogService.open(DialogNoteReworkFase1, {
        data: {
          pratica: pratica,
          isBocciaturaPresidio: true
        },
        header: "Note indicate dal presidio per la bocciatura della pratica "+ pratica.cui.toUpperCase(),
        width: "60%",
        height: "70%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
    }

    consegnaPratica(pratica:PraticaFlowdy2_Firestore){
      this.showDeliverConfirmation = true;
      this.selectedPratica = pratica;
    }

    confermaConsegnaPratica(){
      this.isLoadingResults = true;
      this.praticheService.consegnaFase1(this.selectedPratica.id).subscribe( {
        next: (v) => {
          this.isLoadingResults = false;
          this.messageService.add({severity:'success', summary:'', detail:'FASE 1 della pratica consegnata!', life:5000});
          this.showDeliverConfirmation = false;
          this.selectedPratica = null;
          this.loadPratiche();
        },
        error: (e) => {
            this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di consegna della pratica'});
            this.isLoadingResults = false;
            this.showDeliverConfirmation = false;
            this.selectedPratica = null;
        },
        complete: () => {
        }
      });
    }

    annullaConsegna(pratica:PraticaFlowdy2_Firestore){
      this.showAnnullaConsegnaConfirmation = true;
      this.selectedPratica = pratica;
    }
    confermaAnnullamentoConsegnaPratica(){
      this.isLoadingResults = true;
      this.praticheService.annullaConsegnaFase1(this.selectedPratica.id).subscribe( {
        next: (v) => {
          this.isLoadingResults = false;
          this.messageService.add({severity:'success', summary:'', detail:'Annullamento consegna avvenuto con successo!', life:5000});
          this.showAnnullaConsegnaConfirmation = false;
          this.selectedPratica = null;
          this.isLoadingResults = false;
          this.loadPratiche();
        },
        error: (e) => {
            this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di annullamento della consegna della pratica'});
            this.isLoadingResults = false;
            this.showAnnullaConsegnaConfirmation = false;
            this.selectedPratica = null;
            this.isLoadingResults = false;
        },
        complete: () => {
          
            
        }
      });
    }

    async scaricaPreventivo(pratica:PraticaFlowdy2_Firestore){
      const storage = getStorage();
      this.isLoadingResults = true;
        const pathReferenceFilePreventivo = ref(
          storage,
          "pratiche/scuola/" +
          pratica.cui +
            "/IN/FASE_1/preventivo/"+pratica.cui+".pdf"
        );
  
        const blobPreventivo = await getBlob(pathReferenceFilePreventivo);
        saveAs(blobPreventivo, "preventivo_opere_extra_"+pratica.cui+".pdf");
        this.isLoadingResults = false;
    }

    checkIfDeliverable(pratica: PraticaFlowdy2_Firestore):boolean{
      if( (pratica.statoFlowdyFase1 === 'SOPRALLUOGO EFFETTUATO' || pratica.statoFlowdyFase1 === 'PREVENTIVO IN ATTESA' || pratica.statoFlowdyFase1 === 'PREVENTIVO APPROVATO') && pratica.sopralluogoOk
        //&& (!pratica.opereExtra && pratica.sopralluogoOk)) || (pratica.opereExtra &&pratica.statoFlowdyFase1 === "PREVENTIVO APPROVATO")
      ){

        if(pratica.opereExtra ){
          if (pratica.preventivo && pratica.filePreventivoUploaded){
            if(pratica.fileRETUploaded && pratica.fileDUVRIUploaded && pratica.fileVerbaleSopralluogoUploaded){
              return true;
            }
            return false;
          }
          return false;
        }else {
          if(pratica.fileRETUploaded && pratica.fileDUVRIUploaded && pratica.fileVerbaleSopralluogoUploaded){
            return true;
          }
        }
        return false;
      }
      return false;
    }

    modificaPreventivo(pratica: PraticaFlowdy2_Firestore) {
      this.ref = this.dialogService.open(DialogModificaPreventivoFase1, {
        data: {
          pratica: pratica,
        },
        header: "Modifica PREVENTIVO per la pratica "+ pratica.cui.toUpperCase(),
        width: "50%",
        height: "50%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((modificaPreventivo) => {
        if (modificaPreventivo && modificaPreventivo.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Preventivo modificato con successo!', life:3000});
          this.loadPratiche();
        }
      }); 
    }

    assegnaODA(pratica: PraticaFlowdy2_Firestore){
      const localizzazione:string =   pratica.cui.split("-")[1] === "LIG"?'LIGURIA':pratica.cui.split("-")[1] === 'PIE'?'PIEMONTE':'TOSCANA';
      this.isLoadingResults = true;
      this.odaService.getDisponibiliPerAzienda(pratica.idAziendaFase1, pratica.bando, localizzazione).subscribe( {
        next: (v) => {
          // this.logger.info(JSON.stringify(v));
          if(!v || v.length == 0){
            this.isLoadingResults = false;
            this.messageService.add({life: 10000,severity:'warn', summary:'ATTENZIONE', detail:'Nessun ODA disponibile per l\'azienda '+pratica.azienda+' ed il bando 1'});

          }else{
            this.isLoadingResults = false;
            this.ref = this.dialogService.open(DialogAssegnaOdaFase1, {
              data: {
                pratica: pratica,
                listaOda: v
              },
              header: "Assegna ODA alla pratica "+ pratica.cui.toUpperCase(),
              width: "50%",
              height: "55%",
              baseZIndex: 10000,
              closable: true,
              draggable: false,
            });
            this.ref.onClose.subscribe((confermaAssegnazioneODA) => {
              if (confermaAssegnazioneODA && confermaAssegnazioneODA.success) {
                this.messageService.add({severity:'success', summary:'', detail:'ODA assegnato con successo!', life:3000});
                this.loadPratiche();
              }
            });   
          }
        },
        error: (e) => {
            this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di recupero dell\'oda da assegnare alla pratica'});
            this.isLoadingResults = false;
        },
        complete: () => {
          this.isLoadingResults = false;
           
            
        }
      }); 
    }
    comunicaDataSopralluogo(pratica: PraticaFlowdy2_Firestore) {
      this.ref = this.dialogService.open(DialogComunicaDataSopralluogoFase1, {
        data: {
          pratica: pratica,
        },
        header: "Comunica data prevista per il sopralluogo della pratica "+ pratica.cui.toUpperCase(),
        width: "50%",
        height: "25%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((confermaEsito) => {
        if (confermaEsito && confermaEsito.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Data prevista per il sopralluogo comunicato con successo!', life:3000});
          this.loadPratiche();
        }
      });  
    }
    comunicaEsitoSopralluogo(pratica: PraticaFlowdy2_Firestore) {
      this.ref = this.dialogService.open(DialogEsitoSopralluogoFase1, {
        data: {
          pratica: pratica,
        },
        header: "Comunica esito sopralluogo per la pratica "+ pratica.cui.toUpperCase(),
        width: "80%",
        height: "65%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((confermaEsito) => {
        if (confermaEsito && confermaEsito.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Sopralluogo comunicato con successo!', life:3000});
          this.loadPratiche();
        }
      });  
    }

   
    openPrendiInCarico(pratica: PraticaFlowdy2_Firestore): void {
      this.confirmationService.confirm({
        message: `Confermi di voler prendere in carico la pratica ${pratica.cui}?`,
        header: "Presa in carico",
        icon: "pi pi-File-import",
        acceptLabel: "CONFERMA",
        acceptButtonStyleClass: "p-button-success",
        rejectLabel: "ANNULLA",
        rejectButtonStyleClass: "p-button-warning",
        accept: () => {
          this.isLoadingResults = true;
          if(this.isImpresa){
            let utente:Utente = new Utente();
            utente.id = Number(localStorage.getItem("idUtente"));
            this.praticheService.utentePrendeInCaricoFase1(this.selectedPratica.id, utente).subscribe( {
            next: (v) => {
              this.isLoadingResults = false;
              this.messageService.add({severity:'success', summary:'', detail:'Pratica presa in carico con successo!', life:5000});
              this.loadPratiche();
            },
            error: (e) => {
                this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di presa in carico della pratica'});
                this.isLoadingResults = false;
            },
            complete: () => {
            }
          
          }); 
          }else if(this.isPresidioSF){
            if(pratica.statoFlowdyFase1 === "DA ASSEGNARE" ){
              let utente:Utente = new Utente();
              utente.id = Number(localStorage.getItem("idUtente"));
              this.praticheService.utentePrendeInCaricoFase1(this.selectedPratica.id, utente).subscribe( {
                next: (v) => {
                  this.isLoadingResults = false;
                  this.messageService.add({severity:'success', summary:'', detail:'Pratica presa in carico con successo!', life:5000});
                  this.loadPratiche();
                },
                error: (e) => {
                    this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di presa in carico della pratica'});
                    this.isLoadingResults = false;
                },
                complete: () => {
                }
              });  
            }else{
              this.praticheService.presidioPrendeInCaricoFase1(this.selectedPratica.id).subscribe( {
                next: (v) => {
                  this.isLoadingResults = false;
                  this.messageService.add({severity:'success', summary:'', detail:'Pratica presa in carico con successo!', life:5000});
                  this.loadPratiche();
                },
                error: (e) => {
                    this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di presa in carico della pratica'});
                    this.isLoadingResults = false;
                },
                complete: () => {
                }
              });  
            }
             
          }
          
        },
        reject: () => {
          //this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
        },
      });
    }

    onMostraCompletatiChange(newValue: boolean): void {
      this.mostraPraticheCompletate = newValue
      this.loadPratiche();
    }

    loadPratiche(){
        this.isLoadingResults = true;
        const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
        let query;
      if(this.isPresidioTIM){
        if(this.filterIsSet){
          if(this.filtroLotto){
            // this.logger.info("[PRATICHE FASE 1] PRESIDIO TIM LOADING PRATICHE FASE 1 FILTRO PER LOTTO "+ this.filtroLotto);
            query= collectionRef.where("bando", "==", "BANDO 1")
            .where("lotto", "==", this.filtroLotto)
            //.where("statoFlowdyFase1", "==", "IN CARICO PRESIDIO")
            .orderBy("codiceStatoInfratelFase1");
          }else if(this.filtroStatoInfratel){
            if(this.filtroLottoPerFase){
              // this.logger.info("[PRATICHE FASE 1] PRESIDIO TIM LOADING PRATICHE FASE 1 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel + " E LOTTO "+ this.filtroLottoPerFase);

              query= collectionRef
              .where("bando", "==", "BANDO 1")
              //.where("statoFlowdyFase1", "==", "IN CARICO PRESIDIO")
              .where("lotto", "==", this.filtroLottoPerFase)
              .orderBy("codiceStatoInfratelFase1");

            }else {
              // this.logger.info("[PRATICHE FASE 1] PRESIDIO TIM LOADING PRATICHE FASE 1 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel);

              query= collectionRef
              .where("bando", "==", "BANDO 1")
             // .where("codiceStatoInfratelFase1", "==", this.filtroStatoInfratel)
            //  .where("statoFlowdyFase1", "==", "IN CARICO PRESIDIO")
            //  .where("statoFlowdyFase1", "==", "PUBBLICATA")
              .orderBy("codiceStatoInfratelFase1");

            }
          }else  if(this.filtroInLavorazione){
            // this.logger.info("[PRATICHE FASE 1] PRESIDIO TIM LOADING PRATICHE FASE 1 FILTRO PER IN LAVORAZIONE ");

            query= collectionRef
            .where("bando", "==", "BANDO 1")
            .orderBy("codiceStatoInfratelFase1");
          }else if(this.filtroOda){
            // this.logger.info("[PRATICHE FASE 1] PRESIDIO TIM LOADING PRATICHE FASE 1 FILTRO PER ODA "+ this.filtroOda);
            if(this.filtroDaPagare){
              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("numeroOda", "==", Number(this.filtroOda))
              .orderBy("codiceStatoInfratelFase1");
            }else{
              query= collectionRef.where("bando", "==", "BANDO 2").where("numeroOda", "==", Number(this.filtroOda)).orderBy("codiceStatoInfratelFase1");
            }
           
          }else if(this.filtroImpresa){
            if(!this.filtroRegione){
              if(this.filtroStatoFlowdy){
                this.logger.info("[PRATICHE FASE 1] PRESIDIO TIM: LOADING PRATICHE FASE 1 FILTRO PER IMPRESA "+ this.filtroImpresa + " E STATO FLOWDY "+ this.filtroStatoFlowdy );

                query= collectionRef
                .where("bando", "==", "BANDO 1")
                .where("idAziendaFase1", "==",  Number(this.filtroImpresa))
                .where("statoFlowdyFase1", "==", this.filtroStatoFlowdy)
                .orderBy("statoFlowdyFase1");
              }else{
              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("idAziendaFase1", "==",  Number(this.filtroImpresa))
              .orderBy("codiceStatoInfratelFase1");
              }
            }else {
              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("idAziendaFase1", "==",  Number(this.filtroImpresa))
              .where("regione", "==", this.filtroRegione)
              .orderBy("codiceStatoInfratelFase1");
            }


          }else if(this.filtroPratica){
            this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER PRATICA "+ this.filtroPratica );
            if (this.filtroPratica) {
              query = collectionRef.where("cui", ">=", this.filtroPratica)
                                 .where("cui", "<=", this.filtroPratica + '\uf8ff');
            } else {
              query = collectionRef;
            }
          }
          
        }else{
          // this.logger.info("[PRATICHE FASE 1] PRESIDIO TIM  LOADING PRATICHE FASE 1 SENZA FILTRI");

          if(!this.mostraPraticheCompletate){
             query = collectionRef
              .where("bando", "==", "BANDO 1")
            //  .where("codiceStatoInfratelFase1", "!=", "1-6")
            //  .where("statoFlowdyFase1", "==", "IN CARICO PRESIDIO")
              .orderBy("codiceStatoInfratelFase1");
            
          }else{
            query= collectionRef
            .where("bando", "==", "BANDO 1")
            //.where("statoFlowdyFase1", "==", "IN CARICO PRESIDIO")
            .orderBy("codiceStatoInfratelFase1");
          }
        }
      }else if(this.isImpresa){
        if(this.filterIsSet){
          if(this.filtroLotto){
            // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE PER AZIENDA FASE 1 FILTRO PER LOTTO "+ this.filtroLotto);
           query= collectionRef.where("bando", "==", "BANDO 1")
            .where("lotto", "==", this.filtroLotto)
            .where("codiceStatoInfratelFase1", "!=", "1-6")
            .where("idAziendaFase1", "==", this.userService.getUser().azienda.id)
            .orderBy("codiceStatoInfratelFase1")
            .orderBy("cui");
          }else if(this.filtroStatoInfratel){
            if(this.filtroLottoPerFase){
              // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE PER AZIENDA FASE 1 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel + " E LOTTO "+ this.filtroLottoPerFase);

              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("idAziendaFase1", "==", this.userService.getUser().azienda.id)
              .where("codiceStatoInfratelFase1", "==", this.filtroStatoInfratel)
              .where("lotto", "==", this.filtroLottoPerFase)
              .orderBy("cui");

            }else {
              // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE PER AZIENDA FASE 1 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel);

              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("codiceStatoInfratelFase1", "==", this.filtroStatoInfratel)
              .where("idAziendaFase1", "==", this.userService.getUser().azienda.id)
              .orderBy("cui");

            }
          }else  if(this.filtroInLavorazione){
            // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE PER AZIENDA FASE 1 FILTRO PER IN LAVORAZIONE ");

            query= collectionRef
            .where("bando", "==", "BANDO 1")
            .where("idAziendaFase1", "==", this.userService.getUser().azienda.id)
            .where("codiceStatoInfratelFase1", "!=", "1-6")
            .orderBy("codiceStatoInfratelFase1")
            .orderBy("cui");
          }else  if(this.filtroOda){
            // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE PER AZIENDA FASE 1 FILTRO PER ODA "+ this.filtroOda);
            if(this.filtroDaPagare){
              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("idAziendaFase1", "==", this.userService.getUser().azienda.id)
              .where("codiceStatoInfratelFase1", "==", '1-6')
              .where("numeroOda", "==", Number(this.filtroOda))
              .where("importoPagatoFase1", "==", null)
              .orderBy("codiceStatoInfratelFase1");
            }else{
              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("idAziendaFase1", "==", this.userService.getUser().azienda.id)
              .where("numeroOda", "==", Number(this.filtroOda))
              .orderBy("codiceStatoInfratelFase1");
            }
           
          }else if(this.filtroPratica){
            this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER PRATICA "+ this.filtroPratica );
            query= collectionRef
            .where("idAziendaFase1", "==", this.userService.getUser().azienda.id)
            .where("codiceStatoInfratelFase1", "!=", '1-6');
          }else if(this.filtroImpresa){
            this.logger.info("[PRATICHE FASE 1] IMPRESA: LOADING PRATICHE FASE 1 FILTRO PER IMPRESA "+ this.filtroImpresa );
            query= collectionRef
            .where("bando", "==", "BANDO 1")
            .where("idAziendaFase1", "==",  Number(this.filtroImpresa))
            .orderBy("codiceStatoInfratelFase1");


          }
          
        }else{
          // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE PER AZIENDA FASE 1 SENZA FILTRI");

          if(!this.mostraPraticheCompletate){
             query = collectionRef
              .where("bando", "==", "BANDO 1")
              .where("idAziendaFase1", "==", this.userService.getUser().azienda.id)
              .where("codiceStatoInfratelFase1", "!=", "1-6")
              .orderBy("codiceStatoInfratelFase1");
            
          }else{
            query= collectionRef
            .where("bando", "==", "BANDO 1")
            .where("idAziendaFase1", "==", this.userService.getUser().azienda.id)
            .orderBy("codiceStatoInfratelFase1");
          }
        }
      }else if(this.isPM){
         this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE PER PM FASE 1 ");
        query= collectionRef.where("bando", "==", "BANDO 1")
            //.where("lotto", "==", this.filtroLotto)
            .where("codiceStatoInfratelFase1", "!=", "1-6")
            .where("opereExtra", "==",true )
           // .where("dataEsitoPreventivo", "==",null )
            //.where("preventivoApprovato", "==",false )
            //.where("statoPreventivo", "==",'IN ATTESA' )
            .orderBy("codiceStatoInfratelFase1")
            .orderBy("cui");

      }else if(this.isPresidioSF || this.isAdmin || this.isSuperAdmin || this.isDirigenteFirmaPacchetti || this.isDemo){
        if(this.filterIsSet){
          if(this.filtroLotto){
            // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER LOTTO "+ this.filtroLotto);
           query= collectionRef.where("bando", "==", "BANDO 1")
            .where("lotto", "==", this.filtroLotto)
            .where("codiceStatoInfratelFase1", "!=", "1-6")
            .orderBy("codiceStatoInfratelFase1");
          }else if(this.filtroStatoInfratel){
            if(this.filtroLottoPerFase){
              // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel + " E LOTTO "+ this.filtroLottoPerFase);

              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("codiceStatoInfratelFase1", "==", this.filtroStatoInfratel)
              .where("lotto", "==", this.filtroLottoPerFase)
              .orderBy("codiceStatoInfratelFase1");

            }else {
              // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel);

              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("codiceStatoInfratelFase1", "==", this.filtroStatoInfratel)
              .orderBy("codiceStatoInfratelFase1");

            }
          }else  if(this.filtroInLavorazione){
            // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER IN LAVORAZIONE ");

            query= collectionRef.where("bando", "==", "BANDO 1").where("codiceStatoInfratelFase1", "!=", "1-6").orderBy("codiceStatoInfratelFase1");
          }else  if(this.filtroOda){
           this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER ODA "+ this.filtroOda);
            if(this.filtroDaPagare){
              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("codiceStatoInfratelFase1", "==", '1-6')
             // .where("numeroOdaFase1", "==", Number(this.filtroOda))
              .where("importoPagatoFase1", "==", null)
              .orderBy("codiceStatoInfratelFase1");
            }else{
              query= collectionRef
              .where("bando", "==", "BANDO 1")
            //  .where("numeroOdaFase1", "==", Number(this.filtroOda))
              .orderBy("codiceStatoInfratelFase1");
            }
           
          }else if(this.filtroImpresa){
         //   this.logger.info("[PRATICHE FASE 1] PRESIDIO SF: LOADING PRATICHE FASE 1 FILTRO PER IMPRESA "+ this.filtroImpresa );
            if(!this.filtroRegione){
              if(this.filtroStatoFlowdy){
                this.logger.info("[PRATICHE FASE 1] PRESIDIO SF: LOADING PRATICHE FASE 1 FILTRO PER IMPRESA "+ this.filtroImpresa + " E STATO FLOWDY "+ this.filtroStatoFlowdy );
                query= collectionRef
                .where("bando", "==", "BANDO 1")
                .where("idAziendaFase1", "==",  Number(this.filtroImpresa))
                .where("statoFlowdyFase1", "==", this.filtroStatoFlowdy)
                .orderBy("statoFlowdyFase1");
              }else{
                this.logger.info("[PRATICHE FASE 1] PRESIDIO SF: LOADING PRATICHE FASE 1 FILTRO PER IMPRESA "+ this.filtroImpresa );
                query= collectionRef
                .where("bando", "==", "BANDO 1")
                .where("idAziendaFase1", "==",  Number(this.filtroImpresa))
                .orderBy("codiceStatoInfratelFase1");
              }
            }else{
              this.logger.info("[PRATICHE FASE 1] PRESIDIO SF: LOADING PRATICHE FASE 1 FILTRO PER IMPRESA "+ this.filtroImpresa + " FILTRO PER REGIONE "+ this.filtroRegione );
              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("idAziendaFase1", "==",  Number(this.filtroImpresa))
              .where("regione", "==", this.filtroRegione)
              .orderBy("codiceStatoInfratelFase1");
            }
            

          }else if(this.filtroPratica){
            this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER PRATICA "+ this.filtroPratica );
            query= collectionRef
            .where("codiceStatoInfratelFase1", "==", '1-1')
            .orderBy("codiceStatoInfratelFase1")
            .orderBy("cui");
          }else if(this.filtroStatoFlowdy){
            this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER STATO FLOWDY "+ this.filtroStatoFlowdy );
            query= collectionRef
            .where("statoFlowdyFase1", "==", this.filtroStatoFlowdy)
            .where("bando", "==", "BANDO 1")
            .orderBy("statoFlowdyFase1")
            .orderBy("codiceStatoInfratelFase1");
          }else if(this.filtroStatoSopralluogo){
            if(this.filtroRegione){
              this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER STATO SOPRALLUOGO "+ this.filtroStatoSopralluogo + " FILTRO PER REGIONE "+ this.filtroRegione );
              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("regione", "==", this.filtroRegione)
              .orderBy("codiceStatoInfratelFase1");
            }else{
            this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER STATO SOPRALLUOGO "+ this.filtroStatoSopralluogo );
            query= collectionRef
              .where("bando", "==", "BANDO 1")
              .orderBy("codiceStatoInfratelFase1");
            }
          }
          
        }else{

          if(!this.mostraPraticheCompletate){
            this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 SENZA FILTRI NON COMPLETATE");

             query = collectionRef
              .where("bando", "==", "BANDO 1")
              .where("codiceStatoInfratelFase1", "!=", "1-6")
              .orderBy("codiceStatoInfratelFase1");
            
          }else{
            this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 SENZA FILTRI ED ANCHE LE COMPLETATE");

            query= collectionRef
            .where("bando", "==", "BANDO 1")
            .orderBy("codiceStatoInfratelFase1");
          }
        }
      }

        
        onSnapshot(query, (qs) => {
           this.logger.info("[PRATICHE FASE 1] PRATICHE FASE 1 CARICATE "+ qs.docs.length);
           if(this.filterIsSet && this.filtroImpresa && this.filtroStatoSopralluogo){
            this.logger.info("[PRATICHE FASE 1] DEVO APPLICARE QUESTO FILTRO SU STATO SOPRALLUOGO: "+ this.filtroStatoSopralluogo);
  
            }
          this.pratiche = [];
          this.praticheFiltrate = [];
          

          qs.forEach((doc) => {
            let pratica = doc.data() as PraticaFlowdy2_Firestore;
            
            if(this.isPresidioTIM){
              if(this.filtroStatoInfratel){
                if(pratica.codiceStatoInfratelFase1 === this.filtroStatoInfratel){
  
                  this.pratiche.push(pratica);
                  this.praticheFiltrate.push(pratica);
                }
              }else{
                if(!this.mostraPraticheCompletate){
                  if(pratica.codiceStatoInfratelFase1 === '1-3' || pratica.codiceStatoInfratelFase1 === '1-4' ){
    
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                }else{
                  if(pratica.codiceStatoInfratelFase1 === '1-3' || pratica.codiceStatoInfratelFase1 === '1-4' || pratica.codiceStatoInfratelFase1 === '1-6'){
    
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                }
                
              }
              

            }else{
              if(this.filterIsSet && this.filtroImpresa && !this.filtroStatoSopralluogo){
//() if((pratica.idAziendaFase1 && pratica.idAziendaFase1 === Number(this.filtroImpresa)) ) {
                    //.logger.info("[FASE 1 BANDO 1] PRATICA "+ pratica.cui + "   "+ pratica.codiceStatoInfratelFase1 + " "+ pratica.idAziendaFase2 + " "+ pratica.idAzienda);
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                //  }
                

              }else if(
                this.filterIsSet && !this.filtroImpresa && this.filtroStatoSopralluogo
              ){
               // this.logger.info("[PRATICHE FASE 1] FILTRO PER STATO SOPRALLUOGO: "+ this.filtroStatoSopralluogo);
                switch (this.filtroStatoSopralluogo) {
                  case 'noSopralluogo':
                    if((pratica.statoFlowdyFase1==='IN ATTESA ODA' || pratica.statoFlowdyFase1==='DA ASSEGNARE' || pratica.statoFlowdyFase1==='ASSEGNATA')){
                      this.pratiche.push(pratica);
                      this.praticheFiltrate.push(pratica);
                    }
                    break;
                  case 'noSopralluogoPF':
                      if(!pratica.dataSopralluogo){
                      this.pratiche.push(pratica);
                      this.praticheFiltrate.push(pratica);
                    }
                    break;
                  case 'sopralluogoPianificato':
                     
                      if(pratica.statoFlowdyFase1==='SOPRALLUOGO PIANIFICATO'){
                        this.pratiche.push(pratica);
                        this.praticheFiltrate.push(pratica);
                      }
                   
                    break;
                  case 'sopralluogoEseguito':
                    if(pratica.sopralluogoOk){
                      this.pratiche.push(pratica);
                      this.praticheFiltrate.push(pratica);
                    }
                    break;
                  case 'sopralluogoKO':
                    if(pratica.statoFlowdyFase1==='SOPRALLUOGO KO'){
                      this.pratiche.push(pratica);
                      this.praticheFiltrate.push(pratica);
                    }
                    break;
                  default:
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                    break;
                }
              } else if(this.filterIsSet && this.filtroImpresa && this.filtroStatoSopralluogo ){
               // this.logger.info("[PRATICHE FASE 1] FILTRO PER STATO SOPRALLUOGO: "+ this.filtroStatoSopralluogo);

                switch (this.filtroStatoSopralluogo) {
                  case 'noSopralluogo':
                    //!pratica.showFase2 && 
                    if((pratica.statoFlowdyFase1==='IN ATTESA ODA' || pratica.statoFlowdyFase1==='DA ASSEGNARE' || pratica.statoFlowdyFase1==='ASSEGNATA')){
                      this.pratiche.push(pratica);
                      this.praticheFiltrate.push(pratica);
                    }
                    break;
                  case 'noSopralluogoPF':
                      //!pratica.showFase2 && 
                      if(!pratica.dataSopralluogo){
                      this.pratiche.push(pratica);
                      this.praticheFiltrate.push(pratica);
                    }
                    break;
                  case 'sopralluogoPianificato':
                     
                      if(pratica.statoFlowdyFase1==='SOPRALLUOGO PIANIFICATO'){
                        this.pratiche.push(pratica);
                        this.praticheFiltrate.push(pratica);
                      }
                    /*  if(!pratica.showFase2){ }}else{
                      if(pratica.dataAppuntamentoFase2 && (pratica.statoFlowdyFase1!=='SOPRALLUOGO EFFETTUATO' && pratica.statoFlowdyFase2 === 'APPUNTAMENTO FISSATO')){
                        
                        this.pratiche.push(pratica);
                        this.praticheFiltrate.push(pratica);
                      } 
                    } */
                  
                    break;
                  case 'sopralluogoEseguito':
                    //if(!pratica.showFase2 && pratica.sopralluogoOk){
                    if(pratica.sopralluogoOk){
                      this.pratiche.push(pratica);
                      this.praticheFiltrate.push(pratica);
                    }
                    break;
                  case 'sopralluogoKO':
                    //!pratica.showFase2 &&
                    if(pratica.statoFlowdyFase1==='SOPRALLUOGO KO'){
                    //if( pratica.sopralluogoOk===false){
                      this.pratiche.push(pratica);
                      this.praticheFiltrate.push(pratica);
                    }
                    break;
                  default:
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                    break;
                }
              }
              else if(this.filterIsSet && this.filtroStatoFlowdy){
              //  this.logger.info("[PRATICHE FASE 1] FILTRO PER 2");
                  this.pratiche.push(pratica);
                  this.praticheFiltrate.push(pratica);
                
              }else if(this.filterIsSet && this.filtroOda){
                if((pratica.numeroOdaFase1 && pratica.numeroOdaFase1 === Number(this.filtroOda) || 
                ( !pratica.numeroOdaFase1 && pratica.numeroOda === Number(this.filtroOda)))){
              //    this.logger.info("[PRATICHE FASE 1] FILTRO PER 3");
                  this.pratiche.push(pratica);
                  this.praticheFiltrate.push(pratica);
                } 
              }else{
              //  this.logger.info("[PRATICHE FASE 1] FILTRO PER 4");
                  if(pratica.statoFlowdyFase1!=='SOPRALLUOGO KO'){
                    if (!this.filtroPratica || pratica.cui.includes(this.filtroPratica)) {
                      //if(!pratica.showFase2){
                        this.pratiche.push(pratica);
                        this.praticheFiltrate.push(pratica);
                      //}
                  
                    }
                  }
                }
             
            }
           

           
          });
          this.filtraPratiche(null);
          this.isLoadingResults = false;
        });
  
    }

    checkSopralluogoPassato(pratica:PraticaFlowdy2_Firestore):boolean{
      if(pratica.dataSopralluogo && pratica.statoFlowdyFase1==='SOPRALLUOGO PIANIFICATO'){
        const oggi = new Date(); 
        const dataSopralluogoDaControllare = new Date(pratica.dataSopralluogo.toDate().getFullYear(),  pratica.dataSopralluogo.toDate().getMonth(), pratica.dataSopralluogo.toDate().getDate() + 2); 
      
          if(dataSopralluogoDaControllare < oggi){
            return true
          }
          return false;
        
      }
     
      return false;
      
     }

     getTooltipSopralluogoPassato(pratica:PraticaFlowdy2_Firestore):string{
      if(this.checkSopralluogoPassato(pratica) ){
        const oggi = new Date();
        const dataSopralluogo = pratica.dataSopralluogo.toDate(); // Converte il Firestore Timestamp in un oggetto Date
        const diffTime = Math.abs(oggi.getTime() - dataSopralluogo.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) -1; // Converte il tempo in giorni
          return 'Sopralluogo pianificato '+ diffDays + " giorni fa e di cui non si è comunicato l'esito!"
       
      }
      return '';
     }

     goBack(){
      this.logger.info("[PRATICHE FASE 1] GO BACK FROM: "+ this.paginaBack);
      /* let from = 'WIP_SOPRALLUOGHI';
      if(this.filtroStatoFlowdy){
        from = 'DOCS_FASE1';
      } */
      // Naviga verso la home con i parametri per selezionare il tab corretto
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate([''],
        {
          queryParams: { 
            'bando': '1', // Bando 1
            'from': this.paginaBack
          }, 
            queryParamsHandling: 'merge',
        }
      ));
      this.removeFilter();
     }

    getSopralluogoTooltip(pratica:PraticaFlowdy2_Firestore):string{
      if(!pratica.dataSopralluogo){
        return 'Da effettuarsi';
      }else{
       
        if(pratica.sopralluogoOk){
          return 'Eseguito con successo in data '+ this.utilService.formattaDataDaTimestampFirestore(pratica.dataSopralluogo);
        }else{
          if(pratica.statoFlowdyFase1==='SOPRALLUOGO PIANIFICATO'){
            return 'Pianificato per il giorno '+ this.utilService.formattaDataDaTimestampFirestore(pratica.dataSopralluogo) ;

          }else if(pratica.statoFlowdyFase1==='APPROVATA'){
            return 'Eseguito con successo in data '+ this.utilService.formattaDataDaTimestampFirestore(pratica.dataSopralluogo);

          }else{
            return 'Eseguito in data '+ this.utilService.formattaDataDaTimestampFirestore(pratica.dataSopralluogo) + ' con esito KO!';

          }
        }
      }
    }

    getPreventivoTooltip(pratica:PraticaFlowdy2_Firestore):string{
     return 'Presentato il '+ this.utilService.formattaDataDaTimestampFirestore(pratica.dataPresentazionePreventivo); 
    }

    checkIfInfoAreAvailable(pratica:PraticaFlowdy2_Firestore):boolean{
      if(pratica.sdfPrincipale || pratica.impresaFC){
        return true;
      }
      return false;
    }

    mostraInfo(pratica:PraticaFlowdy2_Firestore){
      this.selectedPratica = pratica;
      this.showDettagliPratica = true;
    }

    getEsitoPreventivoTooltip(pratica:PraticaFlowdy2_Firestore):string{
      if(pratica.statoPreventivo==='IN ATTESA'){
        return 'In attesa di conferma';
      }else if(pratica.statoPreventivo==='APPROVATO'){
        return 'Approvato il '+ this.utilService.formattaDataDaTimestampFirestore(pratica.dataEsitoPreventivo);
      }else{
        let tooltipRespingemnto ='Respinto il '+ this.utilService.formattaDataDaTimestampFirestore(pratica.dataEsitoPreventivo);
        if(pratica.noteRifiutoPreventivo){
          tooltipRespingemnto += " con le seguenti indicazioni: "+ pratica.noteRifiutoPreventivo.toUpperCase();
        }
        return tooltipRespingemnto;
      }
     }

    getOpereExtraTooltip(pratica:PraticaFlowdy2_Firestore):string{
      if(!pratica.opereExtra){
        return 'Non necessarie';
      }else{
        return pratica.noteOpereExtra;
      }
    }
    checkInviataAdInfratel(pratica:PraticaFlowdy2_Firestore):boolean{
      if(pratica.codiceStatoInfratelFase1==='1-5' || pratica.codiceStatoInfratelFase1==='1-6'){
        return true;
      }
      return false;
    }

    filtraPratiche(event: any){
     if(event && event.target){
      this.praticheDT.filterGlobal(event.target.value, 'contains');
     }else {
       
      if(this._filtroPratiche && Object.keys(this._filtroPratiche).length !== 0){

          this.filterTabellaIsSet = true;
          this.praticheFiltrate = this.pratiche.filter((pratica: PraticaFlowdy2_Firestore) => {
            if(
              ((this._filtroPratiche.tipo?.length ?? 0 ) > 0  && (this._filtroPratiche.tipo.indexOf(pratica.tipoSede) == -1 || this._filtroPratiche.tipo.indexOf(pratica.tipoSedeEffettiva) == -1)) ||
          //    ((this._filtroPratiche.tipoEffettivo?.length ?? 0 ) > 0  && (this._filtroPratiche.tipoEffettivo.indexOf(pratica.tipoSedeEffettiva) == -1 || this._filtroPratiche.tipo.indexOf(pratica.tipoSedeEffettiva) == -1)) ||
              ((this._filtroPratiche.statoInfratel?.length ?? 0  > 0 ) &&  this._filtroPratiche.statoInfratel.indexOf(pratica.codiceStatoInfratelFase1) == -1  )   ||
              ((this._filtroPratiche.statoPratica?.length ?? 0  > 0 ) &&  this._filtroPratiche.statoPratica.indexOf(pratica.statoFlowdyFase1) == -1  )  ||
              ((this._filtroPratiche.regione?.length ?? 0  > 0 ) &&  this._filtroPratiche.regione.indexOf(pratica.regione) == -1  )  ||
              ((this._filtroPratiche.impresa?.length ?? 0  > 0 ) &&  this._filtroPratiche.impresa.indexOf(pratica.idAziendaFase1 || pratica.idAziendaFase1) == -1  )  

            ){
              return false;
            }
            
            return true;

          });
        }else{
          this.praticheFiltrate = this.pratiche;
        }
      }
    }

    visualizzaNote(pratica: PraticaFlowdy2_Firestore) {
      this.isLoadingResults = true;
      
      this.praticheService.getNote(pratica.id).subscribe(notePratica=>{
        this.isLoadingResults = false;
        this.ref = this.dialogService.open(StoricoNotePraticaComponent, {
          data: {
            pratica: pratica,
            note: notePratica,
          },
          header: "NOTE della pratica "+pratica.cui,
          width: "50%",
          height: "85%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
      });
    }

    filtraPerStatoInfratel(statoInfratel:string){
      if(!this.filterTabellaIsSet){
        this.praticheDT.filterGlobal(statoInfratel, 'contains');
        this.filterTabellaIsSet = true;
      }else{
        this.praticheDT.clear();
        this.filterTabellaIsSet = false;
      }
    }

    filtraPerOda(numeroOda:number){
      
      if(!this.filterTabellaIsSet){
        if(
          (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) 
        ){
          this.praticheDT.filterGlobal(numeroOda, 'contains');
          this.filterTabellaIsSet = true;
        }
      }else{
        this.praticheDT.clear();
        if((!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) ){
            this.filterTabellaIsSet = false;
        }
      }
      
    }

    filtraPerBando(oda:OdaAtFirestore){
      if(!this.filterTabellaIsSet){
        this.praticheDT.filterGlobal(oda.bando, 'contains');
        this.filterTabellaIsSet = true;
      }else{
        this.praticheDT.clear();
        this.filterTabellaIsSet = false;
      }
      

      
    }
    filtraPerAzienda(azienda:String){
      if(!this.filterTabellaIsSet){
        if(
          (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) 
        ){
          this.praticheDT.filterGlobal(azienda, 'contains');
          this.filterTabellaIsSet = true;
        }
      }else{
        this.praticheDT.clear();
        if((!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) ){
            this.filterTabellaIsSet = false;
        }
      }
     }

    filtraPerLotto(lotto:string){
      if(!this.filterTabellaIsSet){
        if(
          (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) 
        ){
          this.praticheFiltrate = this.pratiche.filter((pratica: PraticaFlowdy2_Firestore) => {
            if(
              pratica.lotto === lotto

            ){
              return true;
            }
            
            return false;

          });
          //this.praticheDT.filterGlobal(lotto, 'contains');
          this.filterTabellaIsSet = true;
        }
      }else{
        this.praticheDT.clear();
        if((!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) ){
            this.filterTabellaIsSet = false;
        }
      }
    
      
    }
    removeFilter(){
      
      if(this.filtroLotto || this.filtroStatoInfratel || this.filtroInLavorazione || this.filtroOda || this.filtroLottoPerFase || this.filtroImpresa || this.filtroPratica || this.filtroStatoFlowdy || this.filtroRegione){
        this.location.replaceState('/pratiche-bando1/fase-1');
        
        this.filterIsSet = false;
        this.filtroLotto = null;
        this.filtroStatoInfratel = null;
        this.filtroInLavorazione = null;
        this.filtroOda = null;
        this.filtroLottoPerFase = null;
        this.filtroImpresa = null;
        this.filtroStatoSopralluogo = "";
        this.ragioneSocialeImpresa = "";
        this.filtroPratica = null;
        this.filtroRegione = null;
        this.filtroStatoFlowdy = null;
        this.loadPratiche();
      }else{
        if(this._filtroPratiche && 
          (this._filtroPratiche.tipo && this._filtroPratiche.tipo.length > 0) || 
          (this._filtroPratiche.statoInfratel && this._filtroPratiche.statoInfratel.length > 0 ) ||
          (this._filtroPratiche.regione && this._filtroPratiche.regione.length > 0 ) ||
          (this._filtroPratiche.statoPratica && this._filtroPratiche.statoPratica.length > 0 ) ||
          (this._filtroPratiche.impresa && this._filtroPratiche.impresa.length > 0 )
        ){
          this._filtroPratiche.tipo           = [];
          this._filtroPratiche.statoInfratel  = [];
          this._filtroPratiche.statoPratica   = [];
          this._filtroPratiche.regione   = [];
          this._filtroPratiche.impresa   = [];
        
        }
        this.filterTabellaIsSet = false;
        this.praticheFiltrate = this.pratiche;
        this.praticheDT.clear();
      }
     
     
    }

    mostraPratiche(oda:OdaAtFirestore, fase:string){

    }

    scaricaReportPratiche(){
      const today = new Date();
      const formattedDate = `${today.getDate().toString().padStart(2, '0')}_${(today.getMonth() + 1).toString().padStart(2, '0')}_${today.getFullYear()}`;
      this.excelService.exportPraticheFase1ToExcel(this.pratiche, `pratiche_bando1_fase1_${formattedDate}.xlsx`, this.isImpresa);
    }

    

    setUserRole(){
      if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "ADMIN"
      ) {
        this.isAdmin = true;
      } else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "SUPERADMIN"
      ) {
        this.isSuperAdmin = true;
      } else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "SMARTFIBER"
      ) {
        this.isPresidioSF = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "PRESIDIO"
      ) {
        this.isPresidioTIM = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "OPERATORE_AZIENDA"
      ) {
        this.isImpresa = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "DIRIGENTE_FIRMA_VERBALI"
      ) {
        this.isDirigenteFirmaVerbali = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "DIRIGENTE_FIRMA_PACCHETTI"
      ) {
        this.isDirigenteFirmaPacchetti = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "PM"
      ) {
        this.isPM = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "DEMO"
      ) {
        this.isDemo = true;
      }
    }
  
  }
